//Abstract
export class VideoPositioningStrategy {
    getVideoNewSize() {
        //returns VideoSizeResult
        throw 'not implemented';
    }

    updateVideoSize(elVideo, videoNewSize) {
        const element = elVideo instanceof HTMLElement ? elVideo : elVideo[0];

        if (element) {
            element.style.width = `${videoNewSize.width}px`;
            element.style.height = `${videoNewSize.height}px`;
        }
    }

    updateVideoLocation(videoSize, elContainer) {
        const element = elContainer instanceof HTMLElement ? elContainer : elContainer[0];

        if (element) {
            element.style.marginTop = '0';
        }
    }
}

export class VideoMetaData {
    constructor(streamWidth, streamHeight) {
        this.streamWidth = streamWidth;
        this.streamHeight = streamHeight;
    }

    get isPortrait() {
        return this.streamWidth < this.streamHeight;
    }

    get aspectRatio() {
        return this.streamWidth > 0 && this.streamHeight > 0 ? this.streamWidth / this.streamHeight : 1;
    }
}

export class VideoSizeResult {
    constructor(newWidth, newHeight) {
        this.width = newWidth;
        this.height = newHeight;
    }
}
